module.exports = __webpack_public_path__ + "static/img/4-1-3.69239da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/4-1-3.png
// module id = XH4P
// module chunks = 0